import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    header: {
      marginBottom: '0px !important',

      '.ant-modal-title': {
        fontSize: token.fontSizeXL
      }
    },

    divider: {
      position: 'relative',
      left: `-${token.paddingLG}px`,
      width: `calc(100% + ${token.paddingLG}px * 2)`
    },

    alert: {
      padding: token.paddingXS,

      '.anticon-info-circle': {
        fontSize: token.fontSizeHeading5,
        marginRight: token.marginXS,
        marginTop: token.marginXXS / 2
      },

      ' .ant-alert-message': {
        marginBottom: token.marginXXS,
        fontSize: token.fontSize,
        color: token.colorTextSecondary
      },

      ' .ant-alert-description': {
        color: token.colorTextSecondary
      }
    }
  }
})
